import cn from 'classnames';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { ButtonUI, formatVariable } from 'sonata-react-components';

import { useDoohInventory } from '@/context/DoohInventoryContext';
import AllowedAdTypesVolumetry from './components/AllowedAdTypesVolumetry';
import CountryVolumetry from './components/CountryVolumetry';
import { DoohInventoryMapVolumetryStyled } from './DoohInventoryMapVolumetry.styled';

type State = {
  showDetail: boolean;
};

function DoohInventoryMapVolumetry() {
  const { formatMessage } = useIntl();
  const { isInventoryLoading, selectedVolumetry, volumetry } = useDoohInventory();
  const [{ showDetail }, setState] = useState<State>({
    showDetail: false
  });

  const mapVolumetry = selectedVolumetry?.publishers ? selectedVolumetry : volumetry;

  const handleDetailToggle = () => {
    setState(prev => ({
      ...prev,
      showDetail: !prev.showDetail
    }));
  };

  const detailContainerClass = cn('doohInventoryMapVolumetry__container', {
    'doohInventoryMapVolumetry__container--show': showDetail
  });

  if (isInventoryLoading || !mapVolumetry) {
    return null;
  }

  return (
    <DoohInventoryMapVolumetryStyled className="doohInventoryMapVolumetry">
      <div className={detailContainerClass}>
        <section className="doohInventoryMapVolumetry__section">
          <div className="doohInventoryMapVolumetry__metric">
            <span className="doohInventoryMapVolumetry__metricValue">{formatVariable(mapVolumetry.adExchanges)}</span>
            <span className="doohInventoryMapVolumetry__metricName">
              {formatMessage({
                defaultMessage: 'Ad Exchanges',
                id: 'doohInventory.volumetry.adExchanges'
              })}
            </span>
          </div>
          <div className="doohInventoryMapVolumetry__metric">
            <span className="doohInventoryMapVolumetry__metricValue">{formatVariable(mapVolumetry.publishers)}</span>
            <span className="doohInventoryMapVolumetry__metricName">
              {formatMessage({
                defaultMessage: 'Publisher',
                id: 'doohInventory.volumetry.publisher'
              })}
            </span>
          </div>
        </section>
        <section className="doohInventoryMapVolumetry__section">
          <div className="doohInventoryMapVolumetry__metric">
            <span className="doohInventoryMapVolumetry__metricValue">{formatVariable(mapVolumetry.venueTypes)}</span>
            <span className="doohInventoryMapVolumetry__metricName">
              {formatMessage({
                defaultMessage: 'Venue Type',
                id: 'doohInventory.volumetry.venueType'
              })}
            </span>
          </div>
          <div className="doohInventoryMapVolumetry__metric">
            <span className="doohInventoryMapVolumetry__metricValue">{formatVariable(mapVolumetry.screens)}</span>
            <span className="doohInventoryMapVolumetry__metricName">
              {formatMessage({
                defaultMessage: 'Screen',
                id: 'doohInventory.volumetry.screen'
              })}
            </span>
          </div>
          <div className="doohInventoryMapVolumetry__metric">
            <span className="doohInventoryMapVolumetry__metricValue">{formatVariable(mapVolumetry.screenTypes)}</span>
            <span className="doohInventoryMapVolumetry__metricName">
              {formatMessage({
                defaultMessage: 'Screen Type',
                id: 'doohInventory.volumetry.screenType'
              })}
            </span>
          </div>
        </section>
        <section className="doohInventoryMapVolumetry__section">
          <AllowedAdTypesVolumetry volumetry={mapVolumetry} />
        </section>
        <section className="doohInventoryMapVolumetry__section">
          <CountryVolumetry volumetry={mapVolumetry} />
        </section>
      </div>
      <div className="doohInventoryMapVolumetry__buttonContainer">
        <ButtonUI
          icon={showDetail ? 'fa fa-times' : undefined}
          id="show-detail-button"
          onClick={handleDetailToggle}
          size="small"
          text={showDetail ? 'Hide Detail' : 'Show Detail'}
          type="secondary"
        />
      </div>
    </DoohInventoryMapVolumetryStyled>
  );
}

export default DoohInventoryMapVolumetry;
